import api from '../services/api';

/**
 * Open a script file securely via a presigned URL.
 * Opens a blank window immediately (required on mobile to avoid popup blocker),
 * then sets the URL once the signed URL is fetched.
 * @param {string} contentId - The content DB id
 */
export async function openScriptSecure(contentId) {
  // Open window synchronously on the user gesture — mobile browsers block popups after async
  const win = window.open('', '_blank');
  try {
    const res = await api.get(`/content/${contentId}/script/url`);
    if (win) {
      win.location.href = res.data.url;
    } else {
      // Fallback: direct navigation if popup was still blocked
      window.location.href = res.data.url;
    }
  } catch (_) {
    if (win) win.close();
    alert('Could not open script file. It may no longer exist.');
  }
}

/**
 * Open a receipt file securely via a presigned URL.
 * @param {string} filename - basename of the receipt file stored in receiptUrl
 */
export async function openReceiptSecure(filename) {
  const win = window.open('', '_blank');
  try {
    const res = await api.get(`/expenses/receipt-file/${filename}`);
    if (win) {
      win.location.href = res.data.url;
    } else {
      window.location.href = res.data.url;
    }
  } catch (_) {
    if (win) win.close();
    alert('Could not open receipt. It may no longer exist.');
  }
}

// Legacy fallback for any remaining path-based references
export const BACKEND_URL =
  (process.env.REACT_APP_API_URL || 'http://localhost:5001/api/v1').replace('/api/v1', '');

export function fileUrl(fileOrPath) {
  if (!fileOrPath) return null;
  if (typeof fileOrPath === 'object' && fileOrPath.url) return fileOrPath.url;
  const filePath = typeof fileOrPath === 'object' ? fileOrPath.path : fileOrPath;
  if (!filePath) return null;
  if (filePath.startsWith('http://') || filePath.startsWith('https://')) return filePath;
  const base = BACKEND_URL.endsWith('/') ? BACKEND_URL.slice(0, -1) : BACKEND_URL;
  const file = filePath.startsWith('/') ? filePath.slice(1) : filePath;
  return `${base}/${file}`;
}
